import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  input,
  InputSignal,
  signal,
  WritableSignal
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'sz-textarea',
  templateUrl: './sz-textarea.component.html',
  styleUrls: ['./sz-textarea.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SzTextareaComponent),
      multi: true
    }
  ]
})
export class SzTextareaComponent implements ControlValueAccessor {
  readonly label: InputSignal<string | null> = input<string | null>(null);
  readonly placeholder: InputSignal<string> = input<string>('');
  readonly rows: InputSignal<number> = input<number>(4);
  readonly helperText: InputSignal<string | null> = input<string | null>(null);
  readonly errorText: InputSignal<string | null> = input<string | null>(null);
  readonly maxLength: InputSignal<number | null> = input<number | null>(null);
  readonly showCounter: InputSignal<boolean> = input<boolean>(false);

  readonly value: WritableSignal<string> = signal<string>('');
  readonly disabledState: WritableSignal<boolean> = signal<boolean>(false);

  private onChange: (value: string) => void = (): void => {};
  private onTouched: () => void = (): void => {};

  writeValue(value: string | null): void {
    this.value.set(value ?? '');
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabledState.set(isDisabled);
  }

  onInput(event: Event): void {
    const target: HTMLTextAreaElement = event.target as HTMLTextAreaElement;
    this.value.set(target.value);
    this.onChange(target.value);
  }

  onBlur(): void {
    this.onTouched();
  }
}
